import { NotificationService } from './../../../shared/notification/notification.service';
import { TaskService } from './../../../tasks/shared/task.service';
import { SelectItem } from 'primeng/api';
import { Component, OnInit, EventEmitter, Output, Input, OnChanges } from '@angular/core';
import { Contact } from '../../../contacts/shared/contact.model';
import { ContactTypeService } from '../../../contacts/contact-type/shared/contact-type.service';
import { ContactType } from '../../../contacts/contact-type/shared/contact-type.model';
import { UserRead } from '../../../users/shared/user-read.model';
import { UserService } from '../../../users/shared/user.service';
import { TaskDto } from 'src/app/tasks/shared/dto/task.dto';
import { TaskTypeSearchDto } from 'src/app/tasks/shared/dto/task-type-search.dto';
import { TaskTypeService } from 'src/app/tasks/shared/task-type.service';
import { ProfileService } from '../../shared/profile.service';
import { ProfileRelationSearch } from '../../shared/profile-relation-search.model';

@Component({
  selector: 'wl-profile-contact-edit',
  templateUrl: './profile-contact-edit.component.html',
  styleUrls: ['./profile-contact-edit.component.less'],
    standalone: false
})
export class ProfileContactEditComponent implements OnInit, OnChanges {
  @Input() profileContact = {} as Contact;
  @Output() submitClicked: EventEmitter<Contact> = new EventEmitter();
  public showDialog = false;
  public isSaving = false;
  public contactTypeItems: SelectItem[] = [];
  public contacteeUserItems: SelectItem[] = [];
  public assignedToUserItems: SelectItem[] = [];
  public userNotFound: boolean;
  public createTask = false;
  public task = {} as TaskDto;
  public taskTypeItems: SelectItem[] = [];
  public relatedProfileItems: SelectItem[] = [];

  private _currentUser: UserRead;
  constructor(
    private _contactTypeService: ContactTypeService,
    private _profileService: ProfileService,
    private _userService: UserService,
    private _taskTypeService: TaskTypeService,
    private _taskService: TaskService,
    private _notificationService: NotificationService
  ) {}

  ngOnInit() {
    this._contactTypeService.getContactTypes({ PageSize: 999 }).then((data) => {
      this.contactTypeItems = data.Result?.map<SelectItem>((contactType) => {
        return { label: contactType.ContactType, value: contactType.ContactType };
      });
    });
    this._userService.getActiveUsers().then((data) => {
      this.contacteeUserItems = data.map<SelectItem>((user) => {
        return { label: user.UserName, value: user.UserName };
      });
      this.assignedToUserItems = data.map<SelectItem>((user) => {
        return { label: user.UserName, value: user.UserNum };
      });
      this._userService.getCurrentUser().then((user) => {
        this._currentUser = user;
        this.profileContact.Contactee = user.UserName;
        this.task.UserNum = user.UserNum;
      });
    });
    this._taskTypeService.search(new TaskTypeSearchDto()).then((result) => {
      this.taskTypeItems = result.Result?.map<SelectItem>((taskType) => {
        return { label: taskType.TaskType1, value: taskType.TaskType1 };
      });
    });
  }

  ngOnChanges(changes: import('@angular/core').SimpleChanges): void {}

  public open() {
    this.showDialog = true;
    if (!this.profileContact.ContactId && this._currentUser) {
      this.profileContact.Contactee = this._currentUser.UserName;
    }
    if (this.profileContact) {
      this._profileService
        .getProfileViewPrimaryRelations({ ProfileId: this.profileContact.ProfileId, PageSize: 0 } as ProfileRelationSearch)
        .then((result) => {
          this.relatedProfileItems = result.Result.map((relation) => {
            return { label: relation.ReportName, value: relation.ReportName };
          });
        });
    }
  }

  public close() {
    this.showDialog = false;
    this.createTask = false;
    this.task = {} as TaskDto;
  }

  public submit() {
    if (this.submitClicked) {
      if (this.createTask) {
        this.isSaving = true;
        this.task.Descr = this.profileContact.Subject;
        this.task.Notes = this.profileContact.Descr;
        this.task.ProfileID = this.profileContact.ProfileId;
        this.task.AssignedBy = this._currentUser?.UserNum;

        this._taskService
          .create(this.task)
          .then(
            () => {
              this.submitClicked.emit(this.profileContact);
            },
            (error) => {
              this._notificationService.httpError(error);
            }
          )
          .finally(() => (this.isSaving = false));
      } else {
        this.submitClicked.emit(this.profileContact);
      }
    }
  }
}
